export default "__VITE_ASSET__9289fb31__"